/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ToolCheckStatus {
  None = 'None',
  Ok = 'Ok',
  Nok = 'Nok'
}
